import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

// const API_ROOT = 'http://localhost:9016/api'

export const getAuditDashboard = () => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/dashboard/main`
  return doGet(url)
}

export const getSummaryOfGrade = (budgetYear) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summaryofgrade?budgetYear=${budgetYear || 0}`
  return doGet(url)
}

export const getSummaryOfDepartment = (budgetYear) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summaryofdepartment?budgetYear=${budgetYear || 0}`
  return doGet(url)
}

export const getSummary5Year = (budgetYear) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summaryof5year?budgetYear=${budgetYear || 0}`
  return doGet(url)
}

export const getSummaryOfIssueCategory = (budgetYear) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summaryofissuecategory?budgetYear=${budgetYear || 0}`
  return doGet(url)
}

export const getSummaryOfStatus = (budgetYear) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/dashboard/summaryofstatus?budgetYear=${budgetYear || 0}`
  return doGet(url)
}

export const getSummaryOfRisk = (req) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summary-of-risk?budgetYear=${req?.budgetYear || 0}&department=${req?.department || ''}`
  return doGet(url)
}

export const getSummaryOfIssue = (req) => {
  const url = `${API_ROOT}/v1/audit/dashboard/summary-of-issue?budgetYear=${req?.budgetYear || 0}&department=${req?.department || ''}`
  return doGet(url)
}

export const getSummaryOfIssueSchema = () => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/v1/audit/dashboard/main-issue`
  return doGet(url)
}
